document.querySelectorAll('.card-product-media').forEach(card => {
  const mainImg = card.querySelector('.card-product__main-image');
  const defaultSrc = mainImg.dataset.defaultSrc;

  card.querySelectorAll('.color-swatch').forEach(swatch => {
    swatch.addEventListener('mouseenter', () => {
      mainImg.src = swatch.dataset.back || swatch.dataset.front;
    });
    swatch.addEventListener('mouseleave', () => {
      mainImg.src = defaultSrc;
    });
  });
});